import { memo } from 'react';
import { XYCoord } from 'react-dnd';

import styled from '@mint-lib/styled';

import { Icon, IconButton, SelectionListItem } from '@myn/mui';

type Props = {
  name: string;
  currentOffset: XYCoord;
};

const GroupedDimensionLayer = ({ name, currentOffset }: Props) => {
  return (
    <DraggableItem
      currentOffset={currentOffset}
      text={name}
      startAdornment={<Icon component="Draggable" />}
      endAdornment={<IconButton variant="icon" icon="Close" size="small" />}
    />
  );
};

const DraggableItem = styled(SelectionListItem)<{ currentOffset: XYCoord }>`
  overflow: hidden;
  position: relative;
  top: ${({ currentOffset }) => `${currentOffset.y - 10}px`};
  left: ${({ currentOffset }) => `${currentOffset.x - 10}px`};
  width: 320px;
  background-color: ${({ theme }) => theme.palette.ui.field02};
  filter: drop-shadow(16px 16px 10px rgba(0, 0, 0, 0.16));
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
`;

export default memo(GroupedDimensionLayer);
